import { render, staticRenderFns } from "./preProblemDialog.vue?vue&type=template&id=281a1891"
import script from "./preProblemDialog.vue?vue&type=script&lang=js"
export * from "./preProblemDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports